import React, { useState, useEffect, useRef } from "react";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import uuid from "react-uuid";
import { Formik, Field } from "formik";
import InputMask from "react-input-mask";
import { connect } from "react-redux";
import { SetUser } from "redux/actions/userActions";
import { get, put, updateMany } from "services";
import { SetLoading } from "redux/actions/loadingActions";
import BaseSelect from "components/baseSelect";
import CurrencyInput from "react-currency-input";
import SolicitudHorario from "./solicitudHorario";
import SolicitudEmpleo from "./solicitudEmpleo";
import { SetOperationSuccess } from "redux/actions/operationSuccessActions";
import { SetHasJobInformation } from "redux/actions/hasJobInformationDataActions";
import Spinner from "react-bootstrap/Spinner";
import { useHistory } from "react-router";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

let yup = require("yup");

const JobAppliedInformationFormWrapper = ({
  user,
  SetLoading,
  SetOperationSuccess,
  opeationSuccess,
  SetHasJobInformation,
  hasJobInformationDataReducer,
}) => {
  const [isRequesting, setIsRequesting] = useState(false);
  const [solicitudHorarios, setSolicitudHorarios] = useState([]);
  const [solicitudEmpleos, setSolicitudEmpleos] = useState([]);
  const [loadForm, setLoadForm] = useState(false);
  const [formContent, setFormContent] = useState({});
  const [formikSchema, setFormikSchema] = useState({});
  const [basicSchema, setBasicSchema] = useState({
    salarioAspirado: yup.string().required("El campo es requerido"),
    //disponibilidadEntradaId: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
    trabajaFeriado: yup.bool(),
    contratoTipoId: yup
      .number()
      .typeError("El campo es numérico")
      .required("El campo es requerido"),
    //puestoCategoriaId: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
  });
  const formRef = useRef();
  const [saveAndContinue, setSaveAndContinue] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const [empresaId, setEmpresaId] = useState(96);

  useEffect(() => {
    (async function mounted() {
      let horarios = [];
      let solicitudes = [];

      let initialSchema = {
        ...basicSchema,
      };

      if (user.esEmpleado) {
        const empresaId = await get(
          `Empleado/GetEmpresaIdByEmpleado/${user.persona.id}`
        );
        setEmpresaId(empresaId.data);
      }

      if (
        !user.persona.solicitudEmpleo ||
        user.persona.solicitudEmpleo.length == 0
      ) {
        let solicitudEmpleo = await get(
          `SolicitudEmpleo/GetByPersonaId/${user.persona.id}`
        );
        if (solicitudEmpleo.data.length > 0) {
          const solicitudesHorarioDB = await get(
            `SolicitudHorarioTipo?$filter=SolicitudEmpleoId eq ${solicitudEmpleo.data[0]?.id}`
          );
          const solicitudEmpleoEmpleadoDB = await get(
            `SolicitudEmpleoEmpleado/GetByPersonaId/${solicitudEmpleo.data[0]?.id}`
          );
          solicitudEmpleo.data[0].solicitudesHorario =
            solicitudesHorarioDB.data;
          solicitudEmpleo.data[0].solicitudEmpleoEmpleado =
            solicitudEmpleoEmpleadoDB.data;
          user.persona.solicitudEmpleo = solicitudEmpleo.data;
        }
      }

      let initialValues = {
        salarioAspirado: hasSolicitudEmpleo()
          ? user.persona.solicitudEmpleo[0].salarioAspirado
          : "",
        //disponibilidadEntradaId: hasSolicitudEmpleo() ? user.persona.solicitudEmpleo[0].disponibilidadEntradaId : '',
        contratoTipoId: hasSolicitudEmpleo()
          ? user.persona.solicitudEmpleo[0].contratoTipoId
          : "",
        //puestoCategoriaId: hasSolicitudEmpleo() ? user.persona.solicitudEmpleo[0].puestoCategoriaId : '',
        trabajaFeriado: hasSolicitudEmpleo()
          ? convertDecimalToBool(user.persona.solicitudEmpleo[0].trabajaFeriado)
          : false,
      };

      if (
        hasSolicitudEmpleo() &&
        user.persona.solicitudEmpleo[0].solicitudesHorario.length > 0
      ) {
        let schema = {};
        let values = {};
        user.persona.solicitudEmpleo[0].solicitudesHorario.forEach(
          (horario) => {
            schema = {
              ...schema,
              [`trabajaDiasSemana_${horario.id}`]: yup.bool(),
              [`trabajaSabado_${horario.id}`]: yup.bool(),
              [`trabajaDomingo_${horario.id}`]: yup.bool(),
              [`horarioTipoId_${horario.id}`]: yup
                .number()
                .typeError("El campo es numérico")
                .required("El campo es requerido"),
            };
            values = {
              ...values,
              [`trabajaDiasSemana_${horario.id}`]: convertDecimalToBool(
                horario.trabajaDiasSemana
              ),
              [`trabajaSabado_${horario.id}`]: convertDecimalToBool(
                horario.trabajaSabado
              ),
              [`trabajaDomingo_${horario.id}`]: convertDecimalToBool(
                horario.trabajaDomingo
              ),
              [`horarioTipoId_${horario.id}`]: Number(horario.horarioTipoId),
            };
            horarios.push({
              id: horario.id,
              estado: horario.estado,
              isNew: false,
            });
          }
        );
        initialSchema = {
          ...initialSchema,
          ...schema,
        };
        initialValues = {
          ...initialValues,
          ...values,
        };
      }

      if (
        hasSolicitudEmpleo() &&
        user.persona.solicitudEmpleo[0].solicitudEmpleoEmpleado.length > 0
      ) {
        let schema = {};
        let values = {};
        user.persona.solicitudEmpleo[0].solicitudEmpleoEmpleado.forEach(
          (solicitud) => {
            schema = {
              ...schema,
              [`nombreEmpleado_${solicitud.id}`]: yup
                .string()
                .matches(
                  /^[A-Za-zá-ýÁ-Ý\s]*$/,
                  "Debe ingresar solo carácteres alfabéticos"
                )
                .required("El campo es requerido"),
              [`familia_${solicitud.id}`]: yup.bool(),
              [`parentescoId_${solicitud.id}`]: yup
                .number()
                .typeError("El campo es numérico")
                .required("El campo es requerido"),
            };
            values = {
              ...values,
              [`nombreEmpleado_${solicitud.id}`]: solicitud.nombreEmpleado,
              [`familia_${solicitud.id}`]: convertDecimalToBool(
                solicitud.familia
              ),
              [`parentescoId_${solicitud.id}`]: Number(solicitud.parentescoId),
            };
            solicitudes.push({
              id: solicitud.id,
              estado: solicitud.estado,
              isNew: false,
            });
          }
        );
        initialSchema = {
          ...initialSchema,
          ...schema,
        };
        initialValues = {
          ...initialValues,
          ...values,
        };
      }

      setSolicitudEmpleos(() => {
        return [...solicitudes];
      });
      setSolicitudHorarios(() => {
        return [...horarios];
      });
      setBasicSchema(() => {
        return initialSchema;
      });
      updateFormik(initialSchema);
      setFormContent(() => {
        return initialValues;
      });
      setLoadForm(true);
    })();
    return function cleanup() {
      setFormContent({});
      setFormikSchema({});
    };
  }, []);

  useEffect(() => {
    if (loadForm) {
      const solicitudEmpleo = user.persona.solicitudEmpleo;
      if (
        !solicitudEmpleo ||
        (solicitudEmpleo && solicitudEmpleo[0].solicitudesHorario.length == 0)
      ) {
        onAddSolicitudHorario();
      }
    }
  }, [loadForm]);

  const notify = (text) =>
    toast.warn(text, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const onSaveAndContinue = () => {
    setIsRequesting(true);
    formRef.current.validateForm().then((data) => {
      if (Object.keys(data).length === 0 && data.constructor === Object) {
        setSaveAndContinue(true);
        formRef.current.handleSubmit();
      }
    });
  };

  const onSave = () => {
    setIsRequesting(true);
    formRef.current.validateForm().then((data) => {
      if (Object.keys(data).length === 0 && data.constructor === Object) {
        setSaveAndContinue(false);
        formRef.current.handleSubmit();
      }
    });
  };

  const onExit = () => {
    history.push({
      pathname: "/jobAppliedInformation",
      state: {
        updateUserData: true,
      },
    });
  };

  const onChangeRadio = (event) => {
    let values = formRef.current.values;
    values[`trabajaFeriado`] = event.target.value == "true" ? true : false;
    // if (event.target.value == "true") {
    //     values[`trabajaFeriado`] = true
    // } else {
    //     values[`trabajaFeriado`] = false
    // }
  };

  const updateFormik = (schema) =>
    setFormikSchema(() => {
      return yup.object(schema);
    });

  // SOLICITUD HORARIO

  const onAddSolicitudHorario = () => {
    const guid = uuid();
    const oldValues = formRef.current.values;
    const newSchema = {
      ...basicSchema,
      [`trabajaDiasSemana_${guid}`]: yup.bool(),
      [`trabajaSabado_${guid}`]: yup.bool(),
      [`trabajaDomingo_${guid}`]: yup.bool(),
      [`horarioTipoId_${guid}`]: yup.number().required("El campo es requerido"),
    };
    setBasicSchema(() => {
      return newSchema;
    });
    setFormContent(() => {
      return {
        ...oldValues,
        [`trabajaDiasSemana_${guid}`]: false,
        [`trabajaSabado_${guid}`]: false,
        [`trabajaDomingo_${guid}`]: false,
        [`horarioTipoId_${guid}`]: "",
      };
    });
    setSolicitudHorarios(() => {
      return [
        ...solicitudHorarios,
        {
          id: guid,
          estado: 1,
          isNew: true,
        },
      ];
    });
    updateFormik(newSchema);
  };

  const onRemoveSolicitudHorario = (identifier) => {
    let newSchema = basicSchema;
    const removedPhone = solicitudHorarios.find((x) => x.id === identifier);
    const oldValues = formRef.current.values;
    const schemaKeys = [
      `trabajaDiasSemana_${identifier}`,
      `trabajaSabado_${identifier}`,
      `trabajaDomingo_${identifier}`,
      `horarioTipoId_${identifier}`,
    ];
    schemaKeys.forEach((key) => {
      delete newSchema[key];
      delete oldValues[key];
    });
    setBasicSchema(() => {
      return newSchema;
    });
    setFormContent(() => {
      return oldValues;
    });
    updateFormik(newSchema);
    if (removedPhone.isNew) {
      setSolicitudHorarios(() => {
        return [...solicitudHorarios.filter((x) => x.id !== identifier)];
      });
    } else {
      removedPhone.estado = 0;
      setSolicitudHorarios(() => {
        return [...solicitudHorarios];
      });
    }
  };

  // SOLICITUD EMPLEO

  const onAddSolicitudEmpleo = () => {
    const guid = uuid();
    const oldValues = formRef.current.values;
    const newSchema = {
      ...basicSchema,
      [`nombreEmpleado_${guid}`]: yup
        .string()
        .matches(
          /^[A-Za-zá-ýÁ-Ý\s]*$/,
          "Debe ingresar solo carácteres alfabéticos"
        )
        .required("El campo es requerido"),
      [`familia_${guid}`]: yup.bool(),
      [`parentescoId_${guid}`]: yup
        .number()
        .typeError("El campo es numérico")
        .required("El campo es requerido"),
    };
    setBasicSchema(() => {
      return newSchema;
    });
    setFormContent(() => {
      return {
        ...oldValues,
        [`nombreEmpleado_${guid}`]: "",
        [`familia_${guid}`]: false,
        [`parentescoId_${guid}`]: "",
      };
    });
    setSolicitudEmpleos(() => {
      return [
        ...solicitudEmpleos,
        {
          id: guid,
          estado: 1,
          isNew: true,
        },
      ];
    });
    updateFormik(newSchema);
  };

  const onRemoveSolicitudEmpleo = (identifier) => {
    let newSchema = basicSchema;
    const removedPhone = solicitudEmpleos.find((x) => x.id === identifier);
    const oldValues = formRef.current.values;
    const schemaKeys = [
      `nombreEmpleado_${identifier}`,
      `familia_${identifier}`,
      `parentescoId_${identifier}`,
    ];
    schemaKeys.forEach((key) => {
      delete newSchema[key];
      delete oldValues[key];
    });
    setBasicSchema(() => {
      return newSchema;
    });
    setFormContent(() => {
      return oldValues;
    });
    updateFormik(newSchema);
    if (removedPhone.isNew) {
      setSolicitudEmpleos(() => {
        return [...solicitudEmpleos.filter((x) => x.id !== identifier)];
      });
    } else {
      removedPhone.estado = 0;
      setSolicitudEmpleos(() => {
        return [...solicitudEmpleos];
      });
    }
  };

  // SUBMIT

  const onFormSubmitted = async (form) => {
    const id = hasSolicitudEmpleo() ? user.persona.solicitudEmpleo[0].id : 0;
    let solicitudesHorario = [];
    let solicitudEmpleoEmpleado = [];
    let isInvalidObject = false;

    solicitudHorarios.forEach((solicitud) => {
      const trabajaDiasSemana = Number(
        solicitud.estado == 0
          ? user.persona.solicitudEmpleo[0].solicitudesHorario.find(
              (x) => x.id == solicitud.id
            )?.trabajaDiasSemana
          : convertBoolToDecimal(form["trabajaDiasSemana_" + solicitud.id])
      );

      const trabajaSabado = Number(
        solicitud.estado == 0
          ? user.persona.solicitudEmpleo[0].solicitudesHorario.find(
              (x) => x.id == solicitud.id
            )?.trabajaSabado
          : convertBoolToDecimal(form["trabajaSabado_" + solicitud.id])
      );

      const trabajaDomingo = Number(
        solicitud.estado == 0
          ? user.persona.solicitudEmpleo[0].solicitudesHorario.find(
              (x) => x.id == solicitud.id
            )?.trabajaDomingo
          : convertBoolToDecimal(form["trabajaDomingo_" + solicitud.id])
      );

      const horarioTipoId = Number(
        solicitud.estado == 0
          ? user.persona.solicitudEmpleo[0].solicitudesHorario.find(
              (x) => x.id == solicitud.id
            )?.horarioTipoId
          : form["horarioTipoId_" + solicitud.id]
      );

      const solicitudHorario = {
        id: solicitud.isNew ? null : solicitud.id,
        estado: solicitud.estado,
        trabajaDiasSemana,
        trabajaSabado,
        trabajaDomingo,
        horarioTipoId,
        solicitudEmpleoId: id,
      };

      const existeHorario = solicitudesHorario.some(
        (horario) =>
          /* horario.trabajaDiasSemana == solicitudHorario.trabajaDiasSemana && 
                horario.trabajaSabado == solicitudHorario.trabajaSabado &&
                horario.trabajaDomingo == solicitudHorario.trabajaDomingo && */
          horario.horarioTipoId == solicitudHorario.horarioTipoId /* &&
                horario.solicitudEmpleoId == solicitudHorario.solicitudEmpleoId */
      );

      if (existeHorario) isInvalidObject = true;

      solicitudesHorario.push(solicitudHorario);
    });

    if (isInvalidObject) {
      notify("No puedes agregar un mismo horario más de una vez");
      return;
    }

    solicitudEmpleos.forEach((solicitud) => {
      const nombreEmpleado =
        solicitud.estado == 0
          ? user.persona.solicitudEmpleo[0].solicitudEmpleoEmpleado.find(
              (x) => x.id == solicitud.id
            )?.nombreEmpleado
          : form["nombreEmpleado_" + solicitud.id];

      const familia = Number(
        solicitud.estado == 0
          ? user.persona.solicitudEmpleo[0].solicitudEmpleoEmpleado.find(
              (x) => x.id == solicitud.id
            )?.familia
          : convertBoolToDecimal(form["familia_" + solicitud.id])
      );

      const parentescoId = Number(
        solicitud.estado == 0
          ? user.persona.solicitudEmpleo[0].solicitudEmpleoEmpleado.find(
              (x) => x.id == solicitud.id
            )?.parentescoId
          : form["parentescoId_" + solicitud.id]
      );

      const solicitudEmpleo = {
        id: solicitud.isNew ? null : solicitud.id,
        estado: solicitud.estado,
        nombreEmpleado,
        familia,
        parentescoId,
        solicitudEmpleoId: id,
      };

      solicitudEmpleoEmpleado.push(solicitudEmpleo);
    });

    var roundedSalarioAspirado = Math.round(
      parseFloat(String(form.salarioAspirado).replaceAll(",", ""))
    );

    if (roundedSalarioAspirado == 0) {
      isInvalidObject = true;
    }

    const solicitudEmpleo = [
      {
        id,
        personaId: user.persona.id,
        estado: hasSolicitudEmpleo()
          ? user.persona.solicitudEmpleo[0].estado
          : 1,
        //puestoCategoriaId: Number(form.puestoCategoriaId),
        //disponibilidadEntradaId: Number(form.disponibilidadEntradaId),
        salarioAspirado: roundedSalarioAspirado,
        contratoTipoId: Number(form.contratoTipoId),
        trabajaFeriado: convertBoolToDecimal(form.trabajaFeriado),
        solicitudesHorario,
        solicitudEmpleoEmpleado,
        actualizacionSolicitudEmpleo: new Date(), // ojo
        empresaId: 96,
        elegible: 0,
      },
    ];

    if (isInvalidObject) {
      notify("No puede tener el campo aspiración salarial con valor 0");
      return;
    }

    setIsLoading(true);

    const response = await updateMany(
      "solicitudEmpleo",
      solicitudEmpleo /*, reCAPTCHA*/
    );
    user.persona = {
      ...user.persona,
      solicitudEmpleo: [...response.data],
    };
    SetUser(user);
    localStorage.setItem("currentUser-ARS", JSON.stringify(user));
    SetOperationSuccess(opeationSuccess + 1);
    if (response && response.data && response.data.some((x) => x.estado == 1)) {
      SetHasJobInformation(true);
    } else {
      SetHasJobInformation(false);
    }
    setIsLoading(false);
    setIsRequesting(false);

    const route = saveAndContinue ? "/attachments" : "/jobAppliedInformation";
    history.push({
      pathname: route,
      state: {
        updateUserData: true,
      },
    });
  };

  const hasSolicitudEmpleo = () => {
    return (
      user.persona.solicitudEmpleo &&
      user.persona.solicitudEmpleo.length > 0 &&
      user.persona.solicitudEmpleo[0] != null
    );
  };

  const convertBoolToDecimal = (value) => {
    return value ? 1 : 0;
  };

  const convertDecimalToBool = (value) => {
    return value == 1;
  };

  return (
    <>
      <ToastContainer />
      {isLoading && (
        <div className={"display-flex flex-direction-row flex-center"}>
          <Spinner
            animation="grow"
            variant="primary"
            className={"is-absolute center-spinner-vertically"}
            size="lg"
          />
        </div>
      )}

      <Card>
        <Card.Body className={"p-40"}>
          {loadForm && (
            <div>
              <Formik
                innerRef={formRef}
                validationSchema={formikSchema}
                onSubmit={onFormSubmitted}
                initialValues={formContent}
                enableReinitialize={true}
                validateOnChange={false}
                validateOnBlur={false}
              >
                {({
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  values,
                  touched,
                  isValid,
                  errors,
                  setFieldValue,
                }) => (
                  <Form noValidate onSubmit={handleSubmit}>
                    <Form.Row>
                      <Form.Group
                        as={Col}
                        md="12"
                        controlId="campos_obligatorios"
                        className="mb-25"
                        style={{ fontSize: 18 }}
                      >
                        <div>
                          <b> Campos obligatorios * </b>
                        </div>
                      </Form.Group>

                      <BaseSelect
                        md={4}
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        values={values}
                        label={"Tipo de contrato *"}
                        name={"contratoTipoId"}
                        url={"ContratoTipo"}
                      />

                      <Form.Group
                        as={Col}
                        md="4"
                        controlId={"validationsalarioAspirado"}
                      >
                        <Form.Label>Aspiración salarial * </Form.Label>
                        <Form.Control
                          as={CurrencyInput}
                          type="text"
                          name={`salarioAspirado`}
                          placeholder="RD$0.00"
                          value={values[`salarioAspirado`]}
                          onChange={(d) => setFieldValue(`salarioAspirado`, d)}
                          isInvalid={!!errors[`salarioAspirado`]}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors[`salarioAspirado`]}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group as={Col} md="4" id="feriadoValidation">
                        <Form.Label>
                          {" "}
                          ¿Puede trabajar días feriados?{" "}
                        </Form.Label>

                        <div onChange={onChangeRadio}>
                          <input
                            type="radio"
                            value="true"
                            name={`trabajaFeriado`}
                            defaultChecked={values[`trabajaFeriado`]}
                          />{" "}
                          Sí &nbsp;&nbsp;
                          <input
                            type="radio"
                            value="false"
                            name={`trabajaFeriado`}
                            defaultChecked={!values[`trabajaFeriado`]}
                          />{" "}
                          No
                        </div>

                        {/* &nbsp;&nbsp; <Field type="checkbox" name="trabajaFeriado"/>
                                                    {' '} {values[`trabajaFeriado`] ? 'Sí' : 'No' } */}
                      </Form.Group>
                    </Form.Row>

                    <Form.Row>
                      <Form.Group as={Col} md="12">
                        <span className={"fs-20"}>
                          {" "}
                          <b> Horarios </b>{" "}
                        </span>
                      </Form.Group>
                    </Form.Row>

                    <Form.Row>
                      {solicitudHorarios
                        .filter(
                          (x) =>
                            x.estado == 1 &&
                            `trabajaDiasSemana_${x.id}` in values
                        )
                        .map((element, i) => {
                          return (
                            <SolicitudHorario
                              empresaId={empresaId}
                              InputMask={InputMask}
                              key={element.id}
                              handleChange={handleChange}
                              errors={errors}
                              touched={touched}
                              values={values}
                              element={element}
                              removePhoneNumber={onRemoveSolicitudHorario}
                              index={i}
                            />
                          );
                        })}
                      <Form.Group as={Col} md="12">
                        <Button onClick={onAddSolicitudHorario}>
                          {" "}
                          Agregar horario <i className="fa fa-clock"></i>{" "}
                        </Button>
                      </Form.Group>
                    </Form.Row>

                    <Form.Row>
                      <Form.Group as={Col} md="12">
                        <span className={"fs-20"}>
                          {" "}
                          <b>
                            {" "}
                            ¿Tienes algún familiar o persona conocida en Humano?{" "}
                          </b>{" "}
                        </span>
                      </Form.Group>
                    </Form.Row>

                    <Form.Row>
                      {solicitudEmpleos
                        .filter(
                          (x) =>
                            x.estado == 1 && `nombreEmpleado_${x.id}` in values
                        )
                        .map((element) => {
                          return (
                            <SolicitudEmpleo
                              InputMask={InputMask}
                              key={element.id}
                              handleChange={handleChange}
                              errors={errors}
                              touched={touched}
                              values={values}
                              element={element}
                              removePhoneNumber={onRemoveSolicitudEmpleo}
                            />
                          );
                        })}
                      <Form.Group as={Col} md="12">
                        <Button onClick={onAddSolicitudEmpleo}>
                          {" "}
                          Sí, agregar empleado/a <i className="fa fa-users"></i>{" "}
                        </Button>
                      </Form.Group>
                    </Form.Row>

                    <Form.Row>
                      <Form.Group
                        className={"display-flex space-between padding-right-0"}
                        as={Col}
                        md="12"
                      >
                        {hasJobInformationDataReducer ? (
                          <Button
                            size="medium"
                            variant="light"
                            onClick={onExit}
                          >
                            {" "}
                            <b> Cancelar edición </b>{" "}
                          </Button>
                        ) : (
                          <div> </div>
                        )}
                        <div>
                          <Button
                            size="medium"
                            type="button"
                            onClick={onSave}
                            disabled={isRequesting}
                          >
                            <b> Guardar </b>
                          </Button>
                          <Button
                            className={"margin-left-5"}
                            size="medium"
                            type="button"
                            onClick={onSaveAndContinue}
                            disabled={isRequesting}
                          >
                            <b> Guardar y continuar </b>
                          </Button>
                        </div>
                      </Form.Group>
                    </Form.Row>
                  </Form>
                )}
              </Formik>
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    opeationSuccess: state.opeationSuccess,
    hasJobInformationDataReducer: state.hasJobInformationDataReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    SetUser: (user) => dispatch(SetUser(user)),
    SetLoading: (value) => dispatch(SetLoading(value)),
    SetOperationSuccess: (value) => dispatch(SetOperationSuccess(value)),
    SetHasJobInformation: (value) => dispatch(SetHasJobInformation(value)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JobAppliedInformationFormWrapper);
